import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import translationVI from './locales/vi.json'
import translationEN from './locales/en.json'

// Translation resources
const resources = {
  vi: { translation: translationVI },
  en: { translation: translationEN }
}

// Language detection configuration
const detectionOptions = {
  // Order of language detection
  order: ['localStorage', 'navigator', 'htmlTag'],
  
  // Cache user language
  caches: ['localStorage'],
  
  // Keys to look for in localStorage
  lookupLocalStorage: 'i18nextLng',
  
  // Don't cache if language is default
  checkWhitelist: true
}

i18n
  .use(LanguageDetector) // Auto-detect user language
  .use(initReactI18next) // Pass i18n to React
  .init({
    resources,
    fallbackLng: 'en', // Fallback to English if language not found
    supportedLngs: ['vi', 'en'],
    
    detection: detectionOptions,
    
    interpolation: {
      escapeValue: false // React already escapes
    },
    
    react: {
      useSuspense: false // Disable suspense for SSR compatibility
    },
    
    // Debug mode (set to false in production)
    debug: false
  })

export default i18n

